/**
 * Circle component renders a circle with a specified color and diameter.
 *
 * @param {Object} props - The properties for the Circle component.
 * @param {string} props.color - The background color of the circle.
 * @param {number|string} props.diameter - The diameter of the circle (e.g., "50px" or 50).
 * @param {React.CSSProperties} [props.style] - Optional additional CSS styles to apply to the circle.
 * @returns {JSX.Element} A styled `div` element representing a circle.
 */
export const Circle = ({ color, diameter, style }) => {
  return (
    <div
      style={{
        backgroundColor: color,
        width: diameter,
        height: diameter,
        borderRadius: "50%",
        ...style,
      }}
    ></div>
  );
};
